var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('span',{staticClass:"close-btn",on:{"click":_vm.closeKeyboard}},[_vm._v("X")]),_c('div',{staticClass:"simple-keyboard hg-theme-default"})])
}
var staticRenderFns = []

export { render, staticRenderFns }